exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "._2l0DXW50h9fq7saRuHZWQR tbody tr {\n  cursor: pointer;\n}\n\n._2l0DXW50h9fq7saRuHZWQR tbody tr._3bB07ERfTPTnpvkK8WtSBP {\n  background-color: #f5f5f5 !important;\n}\n\n._2l0DXW50h9fq7saRuHZWQR tbody tr._3bB07ERfTPTnpvkK8WtSBP:hover {\n  background-color: #e8e8e8 !important;\n}\n\n", "", {"version":3,"sources":["/home/forge/qa.leadpm.io/frontend/src/Screens/Emails/Components/Table.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;CACjB;;AAED;EACE,qCAAqC;CACtC;;AAED;EACE,qCAAqC;CACtC","file":"Table.css","sourcesContent":[".table tbody tr {\n  cursor: pointer;\n}\n\n.table tbody tr.inbound-email-row {\n  background-color: #f5f5f5 !important;\n}\n\n.table tbody tr.inbound-email-row:hover {\n  background-color: #e8e8e8 !important;\n}\n\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"table": "_2l0DXW50h9fq7saRuHZWQR",
	"inbound-email-row": "_3bB07ERfTPTnpvkK8WtSBP",
	"inboundEmailRow": "_3bB07ERfTPTnpvkK8WtSBP"
};